// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.privacy-policy[data-v-a8f72090] {\n  padding: 1rem;\n  line-height: 1.6;\n}\n.privacy-policy h1[data-v-a8f72090], .privacy-policy h2[data-v-a8f72090] {\n  color: #333;\n}\n.privacy-policy a[data-v-a8f72090] {\n  color: #007bff;\n  text-decoration: none;\n}\n.privacy-policy a[data-v-a8f72090]:hover {\n  text-decoration: underline;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
